import { t } from '@/i18n'
import type { ShiftAmount, TillReport } from '@/types'

import { EmptySeparator, InfoItem, Section, TillBreakdown } from './components'

function formatAmounts(amounts: ShiftAmount[]) {
  return amounts
    .map(amount => {
      return {
        method: amount.method,
        expectedEndAmount: amount.expectedEnd,
        endAmount: amount.end || 0
      }
    })
    .reduce(
      (res, amount) => {
        res[amount.method] = amount
        return res
      },
      {} as Record<
        string,
        {
          method: string
          expectedEndAmount: number
          endAmount: number
        }
      >
    )
}

function generateTillReport(report: TillReport, tillName: string) {
  return [
    new Section(`${t('till-report.title')} ${tillName || report.tillName!}`.toUpperCase()),
    new InfoItem(t('till-report.start-date'), report.start, {
      valueType: 'date',
      style: '16px'
    }),
    new InfoItem(t('till-report.end-date'), report.end, {
      valueType: 'date',
      style: '16px'
    }),
    new EmptySeparator(),
    new Section(t('report.till-control')),
    new InfoItem(t('report.till-fund'), report.startAmount || 0, {
      valueType: 'currency'
    }),
    new InfoItem(t('report.pay-in'), report.payIns, {
      valueType: 'currency'
    }),
    new InfoItem(t('report.pay-out'), -report.payOuts, {
      valueType: 'currency'
    }),
    new TillBreakdown(formatAmounts(report.amounts))
  ]
}

export default generateTillReport
